import { ConnectedAccountTransactionRfiStatus } from '@40seas/entities/connected-accounts';
import { EnumColor } from '@40seas/frontend/common/providers';

export const connectedAccountsTransactionRfiStatusMapping = {
    [ConnectedAccountTransactionRfiStatus.Active]: 'success',
    [ConnectedAccountTransactionRfiStatus.ActionRequired]: 'warning',
    [ConnectedAccountTransactionRfiStatus.Pending]: 'info',
    [ConnectedAccountTransactionRfiStatus.Submitted]: 'secondary',
    [ConnectedAccountTransactionRfiStatus.Suspended]: 'error',
    [ConnectedAccountTransactionRfiStatus.Disabled]: 'warning',
} as { [key in ConnectedAccountTransactionRfiStatus]: EnumColor };
